<svg id="score-bubble-svg" viewBox="0 0 50 50" preserveAspectRatio="xMidYMid meet" version="1.1" xmlns="http://www.w3.org/2000/svg" [class.empty]="!question?.score" [class.correct]="question?.score === 'correct'" [class.partial]="question?.score === 'partial'" [class.incorrect]="question?.score === 'incorrect'">
    <circle r="20" cx="25" cy="25" class="outer-circle"></circle>

    <g class="tries-group"></g>

    <text class="question-number" x="25" y="25" dy="0.35em">{{ 'Q' + this.question?.itemNumberInSequence }}</text>
</svg>
